import { c as _c } from "react/compiler-runtime";
import { AnalyticsCharts } from "@components/analytics/analytics-charts";
import { Grid } from "@mui-wrapper";
import { AnalyticsInfoBar } from "@pages/analytics/analytics-info-bar";
import { useCompanyId } from "@context-providers/company-id-provider";
import { fetchCompanyStats } from "@store/analytics/analytics-slice-thunk";
import { useAppDispatch } from "@store/store-helper";
import { useEffect } from "react";

/** Renders workspace tabs in analytics page */
export function WorkspaceAnalytics() {
  const $ = _c(5);
  const dispatch = useAppDispatch();
  const companyId = useCompanyId();
  let t0;
  let t1;
  if ($[0] !== companyId || $[1] !== dispatch) {
    t0 = () => {
      const fetchStats = function fetchStats() {
        dispatch(fetchCompanyStats({
          companyId
        }));
      };
      fetchStats();
    };
    t1 = [companyId, dispatch];
    $[0] = companyId;
    $[1] = dispatch;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Grid sx={{
      width: "100%"
    }}><AnalyticsInfoBar /><AnalyticsCharts /></Grid>;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}